import { handleActions } from 'redux-actions';
import { converge, mergeRight } from 'ramda';

import { FETCH_DELTA_CONFIG_SUCCESS } from 'app/features/deltaConfig/actionTypes';
import { COMPLETE_PAGE } from 'app/features/deltaConfig/constants';
import { pathFromPayload, pickState } from 'app/reducers/helpers';

const initialState = {
  isVisible: false,
  sectionTitle: 'complete_offersection_title',
  imageUrl: `${window.etp.config.assetsUrl}img/complete/banner.png`,
  imageUrl2X: `${window.etp.config.assetsUrl}img/complete/banner@2x.png`,
  redirectUrl: '',
};

const offerBlock = handleActions(
  {
    [FETCH_DELTA_CONFIG_SUCCESS]: converge(mergeRight, [
      pickState,
      pathFromPayload([COMPLETE_PAGE, 'offerSection']),
    ]),
  },
  initialState,
);

export { initialState };

export default offerBlock;
